import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

import CreditsContextProvider from "./Components/ContextProviders/CreditsContextProvider";
import TeamsContextProvider from "./Components/ContextProviders/TeamsContextProvider";
import { SidebarProvider } from "./Components/ContextProviders/SidebarContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SidebarProvider>
      <TeamsContextProvider>
        <CreditsContextProvider>
          <App />
        </CreditsContextProvider>
      </TeamsContextProvider>
    </SidebarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
